<template>
  <div>
    <v-card class="ma-4 mt-2">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :isStateStoringEnabled="true"
          :title="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editStates(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="blue">mdi-state-machine</v-icon>
                </a>
              </template>
              <span>{{ $t("States") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item.Id)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FlowService from '@/services/FlowService';
import States from '@/views/administration/flow/States.vue';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        States,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.childComponents = [
                'Flow',
                'States',
            ];
            if (!vm.childComponents.includes(from.name)) {
                vm.gridInstance.saveState(null);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$nextTick(() => {
            if (this.childComponents.includes(to.name)) {
                const gridState = this.gridInstance.loadState();
                this.gridInstance.saveState(gridState);
            }
            next();
        });
    },
    data() {
        return {
            title: this.$t('Flows'),
            childComponents: [],
            grid: {
                key: 'flowGrid',
                dataSource: FlowService.getGrid(),
                columns: [
                    {
                        field: 'Name',
                        caption: this.$t('Name'),
                        type: 'string',
                    },
                    {
                        field: 'ContentTypesNames',
                        caption: this.$t('ContentTypes'),
                        type: 'string',
                    },
                    {
                        field: 'DefFieldTitle',
                        caption: this.$t('Field'),
                        type: 'string',
                    },
                    {
                        field: 'ActiveNotif',
                        caption: this.$t('Alerts'),
                        type: 'boolean',
                    },
                    {
                        field: 'NotifyByEmail',
                        caption: this.$t('NotifyByEmail'),
                        type: 'boolean',
                    },
                ],
            },
        };
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        editStates(dto) {
            this.$router.push(`/administration/flows/states/${dto.Id}`);
        },
        editItem(flowId) {
            this.$router.push(`/administration/flows/${flowId}`);
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    FlowService.delete(dto.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(
                                this.$t('Flow') + ' ' + this.$t('DeletedSuccessfully')
                            );
                        }
                    });
                }
            });
        },
        add() {
            this.$router.push('/administration/flows/new');
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
    },
};
</script>